module.exports = __webpack_public_path__ + "static/media/terms_banner.83bd9c62.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/terms_banner.png
// module id = 69
// module chunks = 0